import { MarkerClusterer } from "@googlemaps/markerclusterer";
/**
 * This class is used with Event Content module
 */
class EventMap {

    /**
     * @param moduleSelector jQuery selector pointing to the root element of this Event Map module
     */
    constructor(moduleSelector) {
        this.MAP_CONTAINER = $(moduleSelector);
        this.MAP = null;
    }

    /**
     * Handles initialization the Event Map module
     */
    async init() {
        const _THIS = this;
        var eventDetailsMap = _THIS.MAP_CONTAINER[0];
        if (eventDetailsMap == null) {
            return;
        }
        // See: https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        const { Map } = await google.maps.importLibrary('maps');
        const mapOptions =
        {
            zoom: 16,
            mapTypeId: 'roadmap',
            styles: [
                { elementType: 'geometry', stylers: [{ saturation: '-75' }] },
                { featureType: 'road', elementType: 'geometry', stylers: [{ saturation: '-75' }] },
                { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ saturation: '-75' }, { color: '#c9c1a9' }] },
                { featureType: 'road.highway', elementType: 'geometry', stylers: [{ saturation: '-75' }] },
                { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ saturation: '-75' }, { color: '#c9c1a9' }] },
                { featureType: 'transit', elementType: 'geometry', stylers: [{ saturation: '-75' }] },
            ]
        };
        _THIS.MAP = new Map(eventDetailsMap, mapOptions);
        var eventLat = $(eventDetailsMap).attr("eventLat");
        var eventLng = $(eventDetailsMap).attr("eventLng");
        var center = new google.maps.LatLng(eventLat, eventLng);
        _THIS.MAP.setCenter(center);
        var details = [
            {
                position: center,
            }
        ];
        // Create markers.
        var markers = [];
        var infoWin = new google.maps.InfoWindow();
        details.forEach(function (details) {
            var marker = new google.maps.Marker({
                position: details.position,
                map: _THIS.MAP
            });
        });
    }
}

window.EventMap = EventMap;
var eventMapJSLoaded = new CustomEvent("eventMapJSLoaded", {
    detail: {
      message: "EventMap js loaded"
    }
  });
window.dispatchEvent(eventMapJSLoaded);